import { cn, ModeToggle, Separator } from "@devhop/ui";
import { useEffect, useState } from "react";
import { ProfileDropdown } from "@/modules/auth/presentation/ui/ProfileDropdown";
import { SidebarTriggerWithBadge } from "./SidebarTriggerWithBadge";
import { HeaderPortalNotificationsBell } from "./HeaderPortalNotificationsBell";

type HeaderProps = React.HTMLAttributes<HTMLElement> & {
  fixed?: boolean;
  ref?: React.Ref<HTMLElement>;
};

export function Header({ className, fixed, children, ...props }: HeaderProps) {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      setOffset(document.body.scrollTop || document.documentElement.scrollTop);
    };

    document.addEventListener("scroll", onScroll, { passive: true });
    return () => document.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={cn(
        "z-50 h-16 border-border border-b bg-background",
        fixed && "header-fixed peer/header sticky top-0 w-[inherit]",
        offset > 10 && fixed ? "shadow-sm" : "shadow-none",
        className,
      )}
      {...props}
    >
      <div
        className={cn(
          "relative flex h-full items-center gap-3 px-4 sm:gap-4 sm:px-6",
          offset > 10 &&
            fixed &&
            "after:absolute after:inset-0 after:-z-10 after:bg-background/80 after:backdrop-blur-sm",
        )}
      >
        <SidebarTriggerWithBadge
          variant="outline"
          className="max-md:scale-125"
        />
        <Separator orientation="vertical" className="h-6" />

        {children}
        <div className="ms-auto flex items-center gap-2 sm:gap-4">
          <HeaderPortalNotificationsBell />
          <ModeToggle />
          <ProfileDropdown />
        </div>
      </div>
    </header>
  );
}
